<template>
  <div
    component-name="card-collection"
    class="flex flex-col justify-start items-start max-w-full"
    :class="{
      'gap-lg': variant === 'regular',
      'gap-xs': variant === 'small',
    }"
  >
    <btn
      :title="title"
      :action="action"
      class="block w-full relative top-0 left-0 min-w-full leading-none"
    >
      <wrapper-reveal
        class="overflow-hidden relative top-0 left-0 w-full min-w-full leading-none"
        reveal="fade-from-bottom"
      >
        <media
          v-bind="asset"
          :use-bg="false"
          class="w-full min-w-full transition-transform duration-1000 group-hover/btn:scale-105"
          :class="{ '!scale-105': forceMediaHover }"
        />
      </wrapper-reveal>

      <!-- RESOURCE SVG -->
      <wrapper-reveal
        v-if="resource"
        class="absolute inset-0 w-full h-full p-md flex justify-end items-start"
        reveal="fade-from-bottom"
        intensity="soft"
        :delay="150"
      >
        <svg-resource-badge />
      </wrapper-reveal>
      <!-- end RESOURCE SVG -->
    </btn>

    <footer class="flex flex-col min-w-full text-skin-base">
      <btn
        v-if="title"
        :title="title"
        :action="action"
        class="flex w-10/12 text-left"
        @mouseenter="forceMediaHover = $device.isDesktop"
        @mouseleave="forceMediaHover = false"
      >
        <wrapper-split-text reveal="lines" class="w-full">
          <div
            v-html="title"
            class="w-full"
            :class="{
              'text-heading-6': variant === 'regular',
              'text-body-big': variant === 'small',
            }"
          ></div>
        </wrapper-split-text>
      </btn>

      <div
        v-if="
          variant === 'regular' &&
          (text || indoor || outdoor || atelier || resource)
        "
        class="flex flex-col w-full"
      >
        <wrapper-reveal v-if="text" reveal="fade-from-bottom">
          <div
            v-html="text"
            class="text-body text-skin-muted w-3/4 line-clamp-2 laptop:line-clamp-3"
          ></div>
        </wrapper-reveal>

        <div
          class="flex flex-col gap-md w-full mt-md"
          v-if="atelier || resource || indoor || outdoor"
        >
          <wrapper-reveal v-if="atelier || resource" reveal="fade-from-right">
            <div v-if="atelier || resource" class="flex flex-col gap-sm">
              <div v-if="atelier" class="flex items-baseline gap-xs">
                <chip-label variant="text-small" target="atelier" />
                <div
                  class="inline-flex text-overline-small/none text-skin-muted -translate-y-px"
                >
                  <span>{{ $t.labels.designer }}</span>
                  <span>&nbsp;</span>
                  <span>{{ atelier }}</span>
                </div>
              </div>

              <div v-if="resource" class="flex items-center gap-xs">
                <chip-label variant="text-small" target="resource" />
                <div
                  class="inline-flex text-overline-small/none text-skin-muted"
                  v-html="$t.texts.resource_short_desc"
                ></div>
              </div>
            </div>
          </wrapper-reveal>

          <wrapper-reveal
            v-if="indoor || outdoor"
            reveal="fade-from-right"
            class="leading-none"
          >
            <txt-indoor-outdoor :indoor="indoor" :outdoor="outdoor" />
          </wrapper-reveal>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
const props = defineProps({
  variant: {
    type: String,
    required: false,
    validator: function (value) {
      return ["regular", "small"].indexOf(value) !== -1;
    },
    default: "regular",
  },
  indoor: {
    type: Boolean,
    required: true,
    default: false,
  },
  outdoor: {
    type: Boolean,
    required: true,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: false,
  },
  action: {
    type: Object,
    required: true,
  },
  asset: {
    type: Object,
    required: true,
  },
  atelier: {
    type: String,
    required: false,
  },
  resource: {
    type: Boolean,
    required: false,
  },
});

const forceMediaHover = ref(false);
</script>
